// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__35_9t","head":"ProcedureTableInfo_head__3rFM_"};